import React, { useEffect } from 'react';

import { usePagination } from 'react-instantsearch-core';

import Pager, { type PagerProps } from '../../Pager';

interface SearchPaginationProps extends Omit<PagerProps,
'setCurrentPage' |
'containerClassName' |
'disabledClassName' |
'activeClassName' |
'showWhenOnePage'> {
  disableScrollTo?: boolean;
  scrollToPositionTop?: number;
}

const SearchPagination: React.FC<SearchPaginationProps> = ({
  disableScrollTo = false,
  scrollToPositionTop = 0,
  ...props
}) => {
  const pagination = usePagination();

  // Ensure we scroll to top when the page changes.
  useEffect(() => {
    if (!disableScrollTo) {
      window.scrollTo({ top: scrollToPositionTop, behavior: 'smooth' });
    }
  }, [disableScrollTo, scrollToPositionTop, pagination.currentRefinement]);

  return (
    <Pager
      currentPage={pagination.currentRefinement}
      totalPages={pagination.nbPages}
      pageRangeDisplayed={2}
      setCurrentPage={(page: number) => pagination.refine(page)}
      controlled
      {...props}
    />
  );
};

export default SearchPagination;
